let csrfToken: string | null = null;

/**
 * Keeps the current session's CSRF token in this browser tab's JavaScript
 * memory. The main layout initializes it after validating the httpOnly session
 * cookie, so it is available before client data providers make API requests.
 */
function initializeCSRFToken(token: string): void {
    csrfToken = token;
}

function readCSRFToken(): string | null {
    return csrfToken;
}

function clearCSRFToken(): void {
    csrfToken = null;
}

export {
    initializeCSRFToken,
    readCSRFToken,
    clearCSRFToken,
};
